export default "__VITE_ASSET__42bf01ed__"